// extracted by mini-css-extract-plugin
module.exports = {"trans-color":"footer--trans-color","component":"footer--component"};